import jwtAuthAxios from "../../services/jwtAuth";
import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";

export const getSyncLog = createAsyncThunk("gedung/getSyncLog", async () => {
  let token = await localStorage.getItem("auth_token");
  jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
  const response = await jwtAuthAxios.get("v1/sync/log");
  return response.data;
});

const initialState = {
  loading: false,
  dataSync: [],
};

const syncSlice = createSlice({
  name: "sync",
  initialState: initialState,
  extraReducers: (builder) => {
    builder
        .addCase(getSyncLog.pending, (state) => {
          state.loading = true;
        })
        .addCase(getSyncLog.fulfilled, (state, action) => {
          state.dataSync = action.payload;
          state.loading = false;
        })
        .addCase(getSyncLog.rejected, (state, action) => {
          state.loading = false;
          console.error("Error during getMatkul:", action.error);
        });
  },
});

export const syncSelectors = (state) => state.sync;
export default syncSlice.reducer;
